module.exports = {"420203007":"章山街道","420203400":"冶钢农场","420203401":"社区工作管理委员会","420203402":"西塞山工业园区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420203.json
// module id = 1563
// module chunks = 0